import React from 'react'
import styles from './UIGamePlayerInfo.module.scss'
import clsx from 'clsx'
import {UIGamePlayerInfoHeader, type UIGamePlayerInfoHeaderProps} from './UIGamePlayerInfoHeader/UIGamePlayerInfoHeader.tsx'
import {UIGamePlayerInfoFooter, type UIGamePlayerInfoFooterProps} from './UIGamePlayerInfoFooter/UIGamePlayerInfoFooter.tsx'
import {UIGamePlayerInfoBody} from './UIGamePlayerInfoBody/UIGamePlayerInfoBody.tsx'
import {UIGamePlayerInfoExtraFooter, type UIGamePlayerInfoExtraFooterProps} from './UIGamePlayerInfoExtraFooter/UIGamePlayerInfoExtraFooter.tsx'

export type UIGamePlayerInfoHeaderPropsOmitted = Omit<UIGamePlayerInfoHeaderProps, 'color' | 'isMyPlayer'>

const DEFAULT_HEADER_WRAPPER = (header: React.ReactNode) => header

interface UIGamePlayerInfoProps {
    header: UIGamePlayerInfoHeaderPropsOmitted
    headerWrapper?: (header: React.ReactNode) => React.ReactNode
    footer?: UIGamePlayerInfoFooterProps | undefined
    extraFooter: UIGamePlayerInfoExtraFooterProps
    color: string
    isMyPlayer: boolean
    children: React.ReactNode[]
}

export const UIGamePlayerInfo = ({
    header,
    headerWrapper = DEFAULT_HEADER_WRAPPER,
    footer,
    extraFooter,
    color,
    isMyPlayer,
    children,
}: UIGamePlayerInfoProps) => {
    const headerElement = <UIGamePlayerInfoHeader color={color} isMyPlayer={isMyPlayer} {...header} />

    return (
        <div className={styles.container}>
            <div className={clsx(styles.containerInner, {
                [styles.hasFooter]: footer !== undefined,
            })}>
                {headerWrapper(headerElement)}
                <UIGamePlayerInfoBody color={color} isMyPlayer={isMyPlayer}>
                    {children}
                </UIGamePlayerInfoBody>
                {footer && <UIGamePlayerInfoFooter {...footer} />}
            </div>
            <div className={styles.extraFooterContainer}>
                <UIGamePlayerInfoExtraFooter {...extraFooter} />
            </div>
        </div>
    )
}
